import api from "./axios";

export const blogList = async () => {
  try {
    const response = await api.get("/blogs/blogs/listing/");
    return response.data.data;
  } catch (error) {
    throw new Error("Failed to fetch blogs");
  }
};

export const blogdetails = async (blogId) => {
  const response = await api.get(`/blogs/blogs/${blogId}/blog_detail/`);
  return response.data.data;
};

export const bloglike = async (blogId) => {
  const response = await api.post(`/blogs/blogs/${blogId}/like/`);
  return response.data.data;
};

export const blogdislike = async (blogId) => {
  const response = await api.post(`/blogs/blogs/${blogId}/dislike/`);
  return response.data.data;
};

export const blogsave = async (blogId) => {
  const response = await api.post(`/blogs/blogs/${blogId}/save_blog/`);
  return response.data.data;
};

export const addcomment = async (payload) => {
  const response = await api.post("blogs/blogs/comment/", payload);
  return response.data;
};

export const commentlists = async ({ queryKey }) => {
  const [_key, params] = queryKey;
  const response = await api.get("/blogs/blogs/comments/", {
    params,
  });
  return response.data.data;
};

export const successstorydetailed = async ({ queryKey }) => {
  const [_key, params] = queryKey;
  const response = await api.get("/blogs/success-story/detail/", {
    params,
  });
  return response.data.data;
};

export const deletecomment = async (payload) => {
  const response = await api.post("blogs/blogs/delete_comment/", payload);
  return response.data;
};
